import React from 'react'
import { Box } from '@mui/material'
import theme from '../theme'

interface Props {
  children: React.ReactNode
  header?: React.ReactNode
  footer?: React.ReactNode
}

const OneColumnLayout = ({ children, header, footer, ...props }: Props) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '0 20px 20px 20px',
        padding: '30px 0'
      }}
      {...props}
    >
      {header}
      <Box
        sx={{
          width: '65%',
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: '#ffffff',
          borderRadius: theme.borders['rounded-16'],
          padding: theme.space['40'],
          height: 'fit-content',
          gap: theme.space['40']
        }}
      >
        {children}
      </Box>
      {footer}
    </Box>
  )
}

export default OneColumnLayout
